import { render, staticRenderFns } from "./ComplexPermissions.vue?vue&type=template&id=c7ab3638"
import script from "./ComplexPermissions.vue?vue&type=script&lang=js"
export * from "./ComplexPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports